import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const reactivateSubscription = createAsyncThunk(
  'removeDowngrade/reactivateSubscription',
  async (_, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/subscription/reactivate',
      method: 'POST'
    })

    if (!success) {
      return rejectWithValue(response.message)
    }

    return response
  }
)
